export const styles = () => ({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  listItem: {
    border: '1px solid #f3f3f3',
    width: 94,
    margin: 0,
    padding: '18px 6px 14px',
    boxSizing: 'border-box',
    textAlign: 'center',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'var(--color-text-primary)',
    fontSize: 12,
    '&:hover': {
      background: 'var(--color-button-secondary)',
      color: 'var(--color-text-on-secondary)',
      border: '1px solid var(--color-button-secondary)',
    },
    '&:hover svg path': {
      stroke: 'var(--color-text-on-secondary)',
    },
    '&:first-child': {
      borderBottomLeftRadius: 10,
      borderTopLeftRadius: 10,
    },
    '&:last-child': {
      borderBottomRightRadius: 10,
      borderTopRightRadius: 10,
      width: 32,
      justifyContent: 'center'
    },
  },
})
